<template>
  <el-row>
    <!-- <el-row>
      <el-checkbox v-model="options.updateAddressBook">
        Update Addressbook
      </el-checkbox>
      <el-checkbox v-model="options.updateItems">
        Update Items
      </el-checkbox>
    </el-row> -->
    <el-row>
      <el-form
        size="small"
        label-position="top"
      >
        <el-form-item
          label="Carrier Service"
        >
          <el-select
            v-model="consignment.service"
            filterable
            style="width: 100%;"
          >
            <el-option-group
              key="algorithms"
              label="Algorithm"
            >
              <el-option
                key="quoteall"
                value="Quote All Available"
                selected
              >
                <span style="float: left">Quote All Available</span>
              </el-option>
              <el-option
                key="lowest"
                value="Lowest Cost"
              >
                <span style="float: left">Lowest Cost</span>
              </el-option>
            </el-option-group>
            <el-option-group
              v-for="group in services"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.id"
                :label="formatService(item)"
                :value="item.chainit"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.carrier.name }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Despatch Date"
        >
          <el-date-picker
            v-model="consignment.date"
            type="date"
            placeholder="Despatch Date"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item
          label="Reference"
          style="width: 100%;"
        >
          <el-input :model="consignment.ref" />
        </el-form-item>
        <el-form-item
          label="Internal Reference"
          style="width: 100%;"
        >
          <el-input :model="consignment.internal_ref" />
        </el-form-item>
        <el-form-item
          label="Special Instructions"
          style="width: 100%;"
        >
          <el-input :model="consignment.spec_inst" />
        </el-form-item>
        <el-form-item
          label="Delivery Signature Preferences"
        >
          <el-select
            v-model="consignment.atl"
            style="width: 100%;"
          >
            <el-option
              label="Signature Required"
              value="false"
            />
            <el-option
              label="Authority to Leave"
              value="true"
            />
          </el-select>
        </el-form-item>
        <el-divider />
        <el-form-item
          label="Charge Account"
          style="width: 100%;"
        >
          <el-input :model="consignment.charge_account" />
        </el-form-item>
        <el-form-item
          label="Override Price (ex GST)"
          style="width: 100%;"
        >
          <el-input :model="consignment.override" />
        </el-form-item>
      </el-form>
    </el-row>
  </el-row>
</template>
<script>
export default {
  props: {
    consignment: {
      type: Object,
      required: false,
      default: Object
    },
    options: {
      type: Object,
      required: false,
      default: Object
    }
  },
  data () {
    return {
      services: [],
      session: null
    }
  },
  mounted () {
    this.loadSession()
  },
  methods: {
    async loadSession () {
      this.loadCarrierServices((await this.$session.instance).account.id)
    },
    loadCarrierServices (account) {
      this.$sdk.service.list(builder => {
        builder.page = 1
        builder.limit = 100
        builder.include = ['carrier']
        builder.filters = { account_carrier_service_setting_strict_account: [account] }
        builder.order = 'carrier.name:asc'
      }).then(res => {
        this.services = res.sort((a, b) => a.carrier.name.localeCompare(b.carrier.name))
        this.services = this.services.reduce(function (r, a) {
          r[a.carrier.name] = r[a.carrier.name] || []
          r[a.carrier.name].label = a.carrier.name
          r[a.carrier.name].options = r[a.carrier.name].options || []
          r[a.carrier.name].options.push(a)
          return r
        }, Object.create(null))
      })
    },
    formatService (service) {
      if (service) {
        return `${service.carrier.name} [${service.name}]`
      } else return ''
    }
  }
}
</script>
